import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';
import { AddWaterBodiesComponent } from './add-water-bodies.component';
import { AddWaterBodiesRoutingModule } from './add-water-bodies-routing.module';
import { WaterBodiesFormModule } from '../form/water-bodies-form.module';
import { MatRadioModule } from '@angular/material/radio';
import { KebabCasePipe } from '../../../../shared/pipes/kebabCase.pipe';
import { DisplayWaterbodyTileModule } from '../display/display-waterbody-tile/display-waterbody-tile.module';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { PlacesAutocompleteModule } from '../../../../shared/places-autocomplete/places-autocomplete.module';
import { UploadSinglePhotoModule } from '../../../../shared/upload/upload-single-photo/upload-single-photo.module';
import { WysiwygEditorModule } from '../../../../shared/wysiwyg-editor/wysiwyg-editor.module';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  imports: [
    CommonModule,
    AddWaterBodiesRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatInputModule,
    TextMaskModule,
    WaterBodiesFormModule,
    MatRadioModule,
    DisplayWaterbodyTileModule,
    LoadingModule,
    PlacesAutocompleteModule,
    UploadSinglePhotoModule,
    WysiwygEditorModule,
    MatTabsModule,
  ],
  declarations: [AddWaterBodiesComponent, KebabCasePipe],
  exports: [AddWaterBodiesComponent, KebabCasePipe],
  providers: [],
})
export class AddWaterBodiesModule {}
